// IE 2026 09 26 / ODOO-341407: неполная выборка списка (WIDGET-LIST) — сведения для плашки «показаны первые N из M» на вкладках-визуализациях
// (Гант движений, график, пузырьки, карта, сравнение, TreeMap). Грид списка обрезку показывает чипсом страниц (CHIP-Limit «1 / N ›»), а визуализации
// строились из первых limit строк молча: у WIDGET-LIST без doc.limit действует settings limit-default (Bio — 2000 строк), и Гант без чипсов
// показывал 2 000 строк из десятков тысяч без единого признака.
//
// Источник — признак бэка record.doc._limit_truncated (my_database.list_truncation, считается в select_widget_list): {rows, total, offset, limit, by}
// или false (выборка полная). total — тот же COUNT(*) пагинации, что бэк уже считает при строк == limit (второго запроса нет); null — не посчитан.
// Прежний бэк (ключа нет) — тот же расчёт по doc.limit / doc.offset / doc._limit_total_count, только у записей WIDGET-LIST.
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }

export function listLimitInfo(record) {
    const doc = record && record.doc
    if (!doc || typeof doc !== 'object') return null
    if (Object.prototype.hasOwnProperty.call(doc, '_limit_truncated')) {
        const x = doc._limit_truncated
        if (!x || typeof x !== 'object') return null
        const limit = num(x.limit)
        if (!(limit > 0)) return null
        return { rows: num(x.rows), total: x.total == null ? null : num(x.total), offset: Math.max(0, num(x.offset)), limit, by: x.by === 'dataLimit' ? 'dataLimit' : 'limit' }
    }
    if (record.segment !== 'WIDGET-LIST') return null
    const limit = num(doc.limit), offset = Math.max(0, num(doc.offset))
    const total = doc._limit_total_count == null || doc._limit_total_count === '' ? null : num(doc._limit_total_count)
    if (!(limit > 0) || total == null) return null
    if (!(offset > 0 || total > offset + limit)) return null
    return { rows: Math.max(0, Math.min(limit, total - offset)), total, offset, limit, by: 'limit' }
}

// отпечаток выборки: скрытая крестиком плашка возвращается, когда пришла другая выборка (другая страница / другой объём)
export function listLimitSig(info) {
    return info ? `${info.offset}|${info.rows}|${info.total}|${info.limit}` : ''
}
